import React from "react";
import * as PropTypes from "prop-types";
import { field } from "@mc/mc-legacy";
const { MultiSelectField } = field;
/**
 * Společná komponenta pro multiselect
 *
 */

class MultiSelect extends React.Component {
  static propTypes = {
    storeMode: PropTypes.bool,
    typStore: PropTypes.object,
    // číselníkový store
    attrName: PropTypes.string,
    // název atributu pro render checkboxů, většinou "nazev"
    values: PropTypes.array, // název atributu pro render checkboxů, většinou "nazev"
  };
  static defaultProps = {
    storeMode: true,
  };
  getAttrValue = (attrName, object) => {
    if (!!object) {
      return object[attrName];
    }

    return null;
  };
  enumValueToMultiselectValue = ({ id, nazev, ...rest }) => {
    const { attrName } = this.props;
    const attrValue = attrName ? this.getAttrValue(attrName, rest) : null;
    const title = attrValue ? attrValue : nazev;
    return {
      id: `${id}`,
      title,
    };
  };
  storeValuesToMultiselectValues = ({ fetched, isFetching, rows }) => {
    return !isFetching && fetched ? rows.map(this.enumValueToMultiselectValue) : [];
  };

  /**
   * Zvalidujeme jestli se jedná o klasický SimpleList store a jestli mají hodnoty uvnitř id
   * @param typStore
   * @returns {boolean}
   */
  validateStore(typStore) {
    if (typStore && typStore.rows && Array.isArray(typStore.rows)) {
      if (!typStore.rows.length > 0 || typStore.rows[0].id) {
        return true;
      }
    }

    return false;
  }

  getValues = () => {
    const { typStore, storeMode, values } = this.props;

    if (storeMode && this.validateStore(typStore)) {
      return this.storeValuesToMultiselectValues(typStore);
    } else if (values && Array.isArray(values)) {
      return values;
    }

    return [];
  };
  render = () => {
    const { ...other } = this.props;
    const values = this.getValues();
    return (
      <MultiSelectField
        filtering
        resetSelection
        showTitlesCount={1}
        titleDefault="Všechny"
        titleMore="Více druhů"
        values={values}
        {...other}
      />
    );
  };
}

export default MultiSelect;
